// extracted by mini-css-extract-plugin
export var cell = "_5i-4";
export var headerCell = "_5i-2";
export var rowHeader = "_5i-3";
export var table = "_5i-1";
export var tableContainer = "_5i-0";